// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Phone navigation: bottom tab bar + menu sheet.
   Heights are tokens so Layout's content padding and the sheet agree. */
.mnav-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  /* Above the header/content (1030), below Bootstrap's offcanvas (1045) and
     modal (1055) layers so a panel's footer buttons are never covered. */
  z-index: 1035;
  display: flex;
  align-items: stretch;
  height: calc(64px + env(safe-area-inset-bottom, 0px));
  padding: 0 env(safe-area-inset-right, 0px) env(safe-area-inset-bottom, 0px) env(safe-area-inset-left, 0px);
  background: #ffffff;
  border-top: 1px solid #e9ecef;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.07);
}

.mnav-tab {
  flex: 1 1;
  min-width: 0;
  min-height: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 6px 2px;
  border: 0;
  background: none;
  color: #6b7280;
  text-decoration: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.mnav-tab:focus-visible {
  outline: 2px solid #c2185b;
  outline-offset: -4px;
  border-radius: 12px;
}

.mnav-tab-icon {
  width: 48px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  transition: background 0.18s ease, color 0.18s ease;
}

.mnav-tab-label {
  max-width: 100%;
  padding: 0 2px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.15;
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mnav-tab.is-active {
  color: #c2185b;
}

.mnav-tab.is-active .mnav-tab-icon {
  background: rgba(194, 24, 91, 0.12);
}

/* Short landscape phones: icons only, the sheet carries the labels. */
@media (max-height: 500px) {
  .mnav-bar {
    height: calc(48px + env(safe-area-inset-bottom, 0px));
  }
  .mnav-tab-label {
    display: none;
  }
}

/* ── Menu sheet ───────────────────────────────────────────────────────── */
.mnav-scrim {
  position: fixed;
  inset: 0;
  z-index: 1060;
  background: rgba(17, 24, 39, 0.45);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.mnav-scrim.is-open {
  opacity: 1;
}

.mnav-sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1061;
  display: flex;
  flex-direction: column;
  max-height: 85dvh;
  background: #ffffff;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.18);
  transform: translateY(100%);
  transition: transform 0.22s cubic-bezier(0.2, 0.8, 0.2, 1);
  padding-bottom: env(safe-area-inset-bottom, 0px);
  touch-action: pan-y;
}

.mnav-sheet.is-open {
  transform: translateY(0);
}

.mnav-sheet.is-dragging {
  transition: none;
}

@media (prefers-reduced-motion: reduce) {
  .mnav-sheet,
  .mnav-scrim {
    transition: none;
  }
}

.mnav-grabber-zone {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  padding: 10px 0 4px;
  cursor: grab;
  touch-action: none;
}

.mnav-grabber {
  width: 40px;
  height: 4px;
  border-radius: 2px;
  background: #d1d5db;
}

.mnav-sheet-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding: 0 16px 16px;
}

/* Account card */
.mnav-account {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0 14px;
}

.mnav-avatar {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #fdf2f5;
  color: #c2185b;
  font-weight: 700;
  font-size: 18px;
}

.mnav-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mnav-account-name {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mnav-account-plan {
  font-size: 12px;
  color: #6b7280;
}

.mnav-close {
  margin-left: auto;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: #f3f4f6;
  color: #4b5563;
  cursor: pointer;
}

.mnav-quick {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 14px;
}

.mnav-quick-btn {
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 8px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  color: #374151;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

.mnav-setup {
  width: 100%;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 14px;
  padding: 0 14px;
  border: 0;
  border-radius: 12px;
  background: #fffbeb;
  color: #b45309;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

/* Groups */
.mnav-group-title {
  margin: 14px 0 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #9ca3af;
}

.mnav-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(84px, 1fr));
  gap: 8px;
}

.mnav-tile {
  min-height: 84px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  padding: 10px 4px 8px;
  border-radius: 14px;
  color: #374151;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
}

.mnav-tile:active {
  background: #f3f4f6;
}

.mnav-tile:focus-visible {
  outline: 2px solid #c2185b;
  outline-offset: 2px;
}

.mnav-tile-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: #f3f4f6;
  color: #4b5563;
  transition: background 0.15s ease, color 0.15s ease;
}

.mnav-tile-label {
  width: 100%;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.25;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
}

.mnav-tile.is-active .mnav-tile-icon {
  background: rgba(194, 24, 91, 0.12);
  color: #c2185b;
}

.mnav-tile.is-active .mnav-tile-label {
  color: #c2185b;
  font-weight: 700;
}

.mnav-signout {
  width: 100%;
  min-height: 48px;
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid #fecaca;
  border-radius: 12px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

/* Header avatar button (phone) */
.mnav-header-avatar {
  position: relative;
  width: 44px;
  height: 44px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
}

.mnav-header-avatar .mnav-avatar {
  width: 36px;
  height: 36px;
  font-size: 15px;
}

.mnav-header-avatar-dot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #f59e0b;
  border: 2px solid #ffffff;
}

/* ---------- New menu (preview): search, pinned, module tiles with drill-in ---------- */
button.mnav-tile {
  border: 0;
  background: transparent;
  font: inherit;
  cursor: pointer;
  width: 100%;
}
.mnav-search {
  width: 100%;
  min-height: 44px;
  margin: 12px 0 4px;
  padding: 0 14px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #f8f9fb;
  font-size: 15px;
  outline: none;
}
.mnav-search:focus { border-color: #c2185b; background: #fff; }
.mnav-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 44px;
  margin-top: 8px;
  padding: 0 4px;
  border: 0;
  background: none;
  color: #c2185b;
  font-size: 14px;
  font-weight: 600;
}
.mnav-drill-title { margin: 2px 0 0; font-size: 18px; font-weight: 700; color: #1f2937; }
.mnav-empty { padding: 12px 2px; color: #9ca3af; font-size: 13.5px; }
`, "",{"version":3,"sources":["webpack://./src/components/MobileNav/mobileNav.css"],"names":[],"mappings":"AAAA;wEACwE;AACxE;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT;yEACuE;EACvE,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,qDAAqD;EACrD,0GAA0G;EAC1G,mBAAmB;EACnB,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,sEAAsE;AACtE;EACE;IACE,qDAAqD;EACvD;EACA;IACE,aAAa;EACf;AACF;;AAEA,4EAA4E;AAC5E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,2CAA2C;EAC3C,2BAA2B;EAC3B,0DAA0D;EAC1D,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,yFAAyF;AACzF;EACE,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;AACA,qBAAqB,qBAAqB,EAAE,gBAAgB,EAAE;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA,oBAAoB,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACxF,cAAc,iBAAiB,EAAE,cAAc,EAAE,iBAAiB,EAAE","sourcesContent":["/* Phone navigation: bottom tab bar + menu sheet.\n   Heights are tokens so Layout's content padding and the sheet agree. */\n.mnav-bar {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  /* Above the header/content (1030), below Bootstrap's offcanvas (1045) and\n     modal (1055) layers so a panel's footer buttons are never covered. */\n  z-index: 1035;\n  display: flex;\n  align-items: stretch;\n  height: calc(64px + env(safe-area-inset-bottom, 0px));\n  padding: 0 env(safe-area-inset-right, 0px) env(safe-area-inset-bottom, 0px) env(safe-area-inset-left, 0px);\n  background: #ffffff;\n  border-top: 1px solid #e9ecef;\n  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.07);\n}\n\n.mnav-tab {\n  flex: 1 1 0;\n  min-width: 0;\n  min-height: 48px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  padding: 6px 2px;\n  border: 0;\n  background: none;\n  color: #6b7280;\n  text-decoration: none;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mnav-tab:focus-visible {\n  outline: 2px solid #c2185b;\n  outline-offset: -4px;\n  border-radius: 12px;\n}\n\n.mnav-tab-icon {\n  width: 48px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 14px;\n  transition: background 0.18s ease, color 0.18s ease;\n}\n\n.mnav-tab-label {\n  max-width: 100%;\n  padding: 0 2px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mnav-tab.is-active {\n  color: #c2185b;\n}\n\n.mnav-tab.is-active .mnav-tab-icon {\n  background: rgba(194, 24, 91, 0.12);\n}\n\n/* Short landscape phones: icons only, the sheet carries the labels. */\n@media (max-height: 500px) {\n  .mnav-bar {\n    height: calc(48px + env(safe-area-inset-bottom, 0px));\n  }\n  .mnav-tab-label {\n    display: none;\n  }\n}\n\n/* ── Menu sheet ───────────────────────────────────────────────────────── */\n.mnav-scrim {\n  position: fixed;\n  inset: 0;\n  z-index: 1060;\n  background: rgba(17, 24, 39, 0.45);\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.mnav-scrim.is-open {\n  opacity: 1;\n}\n\n.mnav-sheet {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1061;\n  display: flex;\n  flex-direction: column;\n  max-height: 85dvh;\n  background: #ffffff;\n  border-radius: 16px 16px 0 0;\n  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.18);\n  transform: translateY(100%);\n  transition: transform 0.22s cubic-bezier(0.2, 0.8, 0.2, 1);\n  padding-bottom: env(safe-area-inset-bottom, 0px);\n  touch-action: pan-y;\n}\n\n.mnav-sheet.is-open {\n  transform: translateY(0);\n}\n\n.mnav-sheet.is-dragging {\n  transition: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .mnav-sheet,\n  .mnav-scrim {\n    transition: none;\n  }\n}\n\n.mnav-grabber-zone {\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  padding: 10px 0 4px;\n  cursor: grab;\n  touch-action: none;\n}\n\n.mnav-grabber {\n  width: 40px;\n  height: 4px;\n  border-radius: 2px;\n  background: #d1d5db;\n}\n\n.mnav-sheet-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  padding: 0 16px 16px;\n}\n\n/* Account card */\n.mnav-account {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 0 14px;\n}\n\n.mnav-avatar {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: #fdf2f5;\n  color: #c2185b;\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.mnav-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.mnav-account-name {\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1.25;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mnav-account-plan {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.mnav-close {\n  margin-left: auto;\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  border-radius: 50%;\n  background: #f3f4f6;\n  color: #4b5563;\n  cursor: pointer;\n}\n\n.mnav-quick {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n.mnav-quick-btn {\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0 8px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #ffffff;\n  color: #374151;\n  font-size: 13px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.mnav-setup {\n  width: 100%;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 14px;\n  padding: 0 14px;\n  border: 0;\n  border-radius: 12px;\n  background: #fffbeb;\n  color: #b45309;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n/* Groups */\n.mnav-group-title {\n  margin: 14px 0 8px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #9ca3af;\n}\n\n.mnav-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(84px, 1fr));\n  gap: 8px;\n}\n\n.mnav-tile {\n  min-height: 84px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 6px;\n  padding: 10px 4px 8px;\n  border-radius: 14px;\n  color: #374151;\n  text-decoration: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.mnav-tile:active {\n  background: #f3f4f6;\n}\n\n.mnav-tile:focus-visible {\n  outline: 2px solid #c2185b;\n  outline-offset: 2px;\n}\n\n.mnav-tile-icon {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 14px;\n  background: #f3f4f6;\n  color: #4b5563;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.mnav-tile-label {\n  width: 100%;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.25;\n  text-align: center;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  overflow-wrap: anywhere;\n}\n\n.mnav-tile.is-active .mnav-tile-icon {\n  background: rgba(194, 24, 91, 0.12);\n  color: #c2185b;\n}\n\n.mnav-tile.is-active .mnav-tile-label {\n  color: #c2185b;\n  font-weight: 700;\n}\n\n.mnav-signout {\n  width: 100%;\n  min-height: 48px;\n  margin-top: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: 1px solid #fecaca;\n  border-radius: 12px;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n/* Header avatar button (phone) */\n.mnav-header-avatar {\n  position: relative;\n  width: 44px;\n  height: 44px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  cursor: pointer;\n}\n\n.mnav-header-avatar .mnav-avatar {\n  width: 36px;\n  height: 36px;\n  font-size: 15px;\n}\n\n.mnav-header-avatar-dot {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #f59e0b;\n  border: 2px solid #ffffff;\n}\n\n/* ---------- New menu (preview): search, pinned, module tiles with drill-in ---------- */\nbutton.mnav-tile {\n  border: 0;\n  background: transparent;\n  font: inherit;\n  cursor: pointer;\n  width: 100%;\n}\n.mnav-search {\n  width: 100%;\n  min-height: 44px;\n  margin: 12px 0 4px;\n  padding: 0 14px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #f8f9fb;\n  font-size: 15px;\n  outline: none;\n}\n.mnav-search:focus { border-color: #c2185b; background: #fff; }\n.mnav-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 44px;\n  margin-top: 8px;\n  padding: 0 4px;\n  border: 0;\n  background: none;\n  color: #c2185b;\n  font-size: 14px;\n  font-weight: 600;\n}\n.mnav-drill-title { margin: 2px 0 0; font-size: 18px; font-weight: 700; color: #1f2937; }\n.mnav-empty { padding: 12px 2px; color: #9ca3af; font-size: 13.5px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
